export const discover = {
  title: "さがす",
  available: "利用可能",
  coins: "コイン",
  list: {
    empty: "ユーザーが見つかりませんでした",
  },
  // 一覧カードの年齢表示（さがす・おすすめ・検索結果で共通）
  ageLabel: (args: { age: number }) => `${args.age}歳`,
  recentVideoCallSection: {
    title: "今すぐビデオ通話できる女の子",
    empty: "今すぐ通話できる女の子はいません。",
    minutesAgoCall: (args: { count: string | number }) =>
      `${args.count}分前に通話`,
    hoursAgoCall: (args: { count: string | number }) =>
      `${args.count}時間前に通話`,
    callButton: "発信",
  },
  // coco+ のおすすめ枠（A/B の B 群。メッセージ起点で案内する）
  cocoplusRecommend: {
    title: "あなたにピッタリの女の子",
    nameAge: (args: { name: string; age: number }) =>
      `${args.name} ${args.age}`,
    score: (args: { score: number }) => args.score.toFixed(1),
    sendMessage: "無料でメッセージを送る",
    /** 送信（いいね）後のボタン。サーバーがいいねの定型メッセージをトークに送る */
    sent: "送信済み",
    sendFailed: "送信できませんでした。時間をおいてお試しください",
    ageLabel: (args: { age: number }) => `${args.age}歳`,
  },
  highReviewScoreSection: {
    title: "評価が高い女の子",
    empty: "評価が高い女の子はいません。",
  },
  preferenceMatchSection: {
    title: "あなたの好みに合う子",
    empty: "好みの条件に合う女の子が見つかりませんでした。",
  },
  seeMore: {
    button: "もっと見る",
    /** キャンペーン見出しの右の正円ボタン */
    campaignButton: "探しに行く",
    error: "読み込みに失敗しました",
    retry: "再試行",
  },
  /** coco+ の「今すぐビデオ通話できる女の子」見出し右のリンク */
  cocoplusSeeAll: "すべて",
  cocoplusTabs: {
    highRated: "評価が高い女の子✨",
    preferenceMatch: "あなたの好みに合う女の子💕",
    newcomer: "最近始めた女の子🔰",
    nearby: "近くに住んでる女の子📍",
    ranking: "ランキング👑",
    live: "ライブ配信🔴",
  },
  /** coco+ の「評価が高い女の子」タブの上に出す条件の説明（サーバーの抽出条件：レビュー50件以上・平均4.0以上） */
  cocoplusHighRatedCriteria: "評価 ★4.0以上・レビュー50件以上",
  cocoplusFilter: "絞り込み",
  /** coco+ の「今すぐビデオ通話できる女の子」一覧で、絞り込み条件に合う子がいないとき */
  cocoplusInstantCallFilterEmpty: "条件に合う女の子はいません。",
  /** coco+ のさがす「ランキング」タブ */
  cocoplusRanking: {
    message: "メッセージ",
    video: "ビデオ",
    online: "オンライン",
    nameAge: (args: { name: string; age: number }) =>
      `${args.name} ${args.age}`,
    score: (args: { score: number }) => args.score.toFixed(1),
    rankLabel: (args: { rank: number }) => `${args.rank}位`,
    empty: "ランキングはまだありません。",
  },
  /** coco+ のさがす「ライブ配信」タブ */
  cocoplusLive: {
    onAir: "配信中",
    count: (args: { count: number }) => `${args.count}人`,
    nameAge: (args: { name: string; age?: number }) =>
      args.age ? `${args.name} ${args.age}` : args.name,
    viewers: (args: { count: number }) => `視聴者${args.count}人`,
    empty: "いま配信している女の子はいません。",
  },
  cocoplusEmpty: {
    highRated: "評価が高い女の子はいません。",
    preferenceMatch: "好みの条件に合う女の子が見つかりませんでした。",
    newcomer: "最近始めた女の子はいません。",
    nearby: "近くに住んでる女の子はいません。",
    nearbyNoRegion: "居住地が未設定のため表示できません。",
  },
  sakura: {
    tabs: {
      newcomer: "最近はじめた女の子",
      recommended: "おすすめ",
      highRated: "高評価",
    },
    instantCallTitle: "すぐ通話ができる女の子",
    highReviewTitle: "評価が高いユーザー",
    rankingTitle: "ビデオ通話ランキング",
    preferenceMatchTitle: "あなたの好みに合う子",
    browseTitle: "女の子をさがす",
    callButton: "通話",
    instantCallButton: "発信",
    reviewCount: (args: { count: string | number }) => `（${args.count}件）`,
    reviewCountShort: (args: { count: string | number }) => `(${args.count})`,
  },
  // Carina のさがす画面（白ヘッダー＋チップ列＋右下の条件指定シート）
  carina: {
    nicknamePlaceholder: "女の子をさがす",
    chips: {
      video: "今すぐビデオ通話",
      new: "新人",
      nearby: "近くに住んでる",
      lovense: "Lovense",
      age: "年齢",
      area: "エリア",
      cup: "カップ数",
    },
    cupIcon: "👙",
    matchCount: (args: { count: number }) => `${args.count}`,
    matchCountOver: (args: { count: number }) => `${args.count}+`,
    matchSuffix: "人が条件に一致",
    noMatch: "条件に合う人がいませんでした",
    clearConditions: "条件をクリア",
    openFilter: "絞り込み",
    onboarding: {
      next: "次へ",
      start: "はじめる",
      steps: {
        search: {
          title: "ニックネームで検索",
          body: "名前を入れるとすぐ探せます",
        },
        chips: {
          title: "タップで絞り込み",
          body: "チップを押すとすぐ一覧が変わります",
        },
        fab: {
          title: "細かい条件はここから",
          body: "評価や体型なども指定できます",
        },
      },
    },
    sheet: {
      title: "条件を指定して検索",
      preferences: "こだわり",
      clear: "クリア",
      matchLabel: "該当",
      personSuffix: "人",
      submit: "この条件で検索",
    },
  },
} as const;
